import { render, staticRenderFns } from "./printVoucher.vue?vue&type=template&id=c872bdf2&scoped=true"
import script from "./printVoucher.vue?vue&type=script&lang=js"
export * from "./printVoucher.vue?vue&type=script&lang=js"
import style0 from "./printVoucher.vue?vue&type=style&index=0&id=c872bdf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c872bdf2",
  null
  
)

export default component.exports